import Alert from 'components/Alert'
import { FC } from 'react'
import { AppsLink } from '@wellesley/router/AppsLink'

const FollowersWarning: FC = () => (
  <Alert type="neutral" style="filled">
    Open account: anyone can follow and view follower-only content.&nbsp;
    <AppsLink
      to="/settings/privacy"
      target="_blank"
      className="text-sm font-medium text-blue-500"
      queryParams={{ target: 'user.follow-autoAccept' }}
    >
      Change settings
    </AppsLink>
  </Alert>
)

export default FollowersWarning
